<script setup lang="ts">
import { useProductStore } from "../lib/product-store";
import { sortSizeOptions } from "~/shared/lib/utils/sort-size-options";
import { getProductVariantPurchaseSource } from "~/shared/lib/product-availability";
import type { MarketplaceAvailabilityItem } from "../model/marketplace-availability";

const productStore = useProductStore();
const { size, product } = storeToRefs(productStore);
const { marketplaceAvailability = {}, isInClickAndCollectChannel = false } = defineProps<{
    isInClickAndCollectChannel?: boolean;
    marketplaceAvailability?: Record<string, MarketplaceAvailabilityItem[]>;
}>();

const sizeOption = computed(() => {
    return product.value?.options?.find(
        (o) => o.title.toLowerCase() === "size",
    );
});
const options = computed(() => {
    const list =
        product.value?.variants
            ?.flatMap((variant) => {
                const option = variant.options?.find(
                    (o) => o.option_id === sizeOption.value?.id,
                );
                return option
                    ? [
                          {
                              ...option,
                              metadata: {
                                  ...option.metadata,
                                  available:
                                      getProductVariantPurchaseSource(
                                          variant,
                                          isInClickAndCollectChannel,
                                          marketplaceAvailability[variant.id],
                                      ) !== "offline",
                              },
                          },
                      ]
                    : [];
            }) ?? [];
    return sortSizeOptions(list, product.value?.variants ?? []);
});

function selectSize(item: (typeof options.value)[number]) {
    if (!item?.metadata?.available) return;
    productStore.selectSize(item);
}
</script>
<template>
    <section class="flex flex-col gap-4 my-4 lg:my-5">
        <span class="text-black/50">Размеры</span>
        <div
            class="flex text-base leading-5 gap-y-4 gap-5 w-full max-w-full flex-wrap"
        >
            <label
                v-for="item of options"
                :key="item.id"
                class="cursor-pointer border rounded-md relative px-1.25"
                :class="{
                    '  border-blue ': size?.id === item?.id,
                    ' border-transparent': size?.id !== item?.id,
                    'cursor-not-allowed text-black/30':
                        !item?.metadata?.available,
                }"
                :aria-disabled="!item?.metadata?.available"
                @click="selectSize(item)"
            >
                {{ item?.value }}
            </label>
        </div>
    </section>
</template>
